import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';

const ParagraphPressOverview = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({});

  return (
    <View
      id="recent_articles"
      display="press"
      page={currentPage}
      filters={filters}
      setFilters={setFilters}
      setCurrentPage={setCurrentPage}
    />
  );
};

export default ParagraphPressOverview;
